export default {
  app: {
    name: 'NomadMate',
  },
  notFound: {
    title: 'Pagina non trovata',
    description: 'La pagina che stai cercando non esiste',
    goBack: 'Torna alla home',
  },
  common: {
    loading: 'Caricamento...',
    noData: 'Nessun dato disponibile',
    error: 'Si è verificato un errore, riprova',
    retry: 'Riprova',
    authExpired: 'Sessione scaduta, accedi di nuovo',
    requestFailed: 'Richiesta fallita',
    networkError: 'Errore di rete, verifica la connessione',
    skipToContent: 'Vai al contenuto principale',
  },
  nav: {
    dashboard: 'Cruscotto',
    visa: 'Visto',
    cost: 'Costo',
    timezone: 'Fuso orario',
    tax: 'Fiscalià',
    guide: 'Guida',
    login: 'Accedi',
  },
  footer: {
    about: 'Chi siamo',
    privacy: 'Privacy',
    terms: 'Termini',
    copyright: '© 2026 NomadMate',
  },
  index: {
    hero: {
      title: 'La tua vita da nomade digitale, organizzata',
      subtitle: 'Piattaforma completa per tracciamento visti, confronto costi, coordinamento fusi orari, conformità fiscale e guide cittadine',
      cta: 'Inizia gratis',
      learnMore: 'Scopri di più',
    },
    features: {
      title: 'Funzionalità',
      visa: { title: 'Tracciamento visto', desc: 'Traccia tipi di visto, validità e promemoria di rinnovo' },
      cost: { title: 'Confronto costi', desc: 'Confronta i costi di vita: alloggio, cibo, trasporti e altro' },
      timezone: { title: 'Gestione fusi', desc: 'Orologi multi-fuso e coordinamento riunioni tra fusi orari' },
      tax: { title: 'Assistente fiscale', desc: 'Consultazione regole fiscali transfrontaliere e avvisi di residenza' },
      guide: { title: 'Guida città', desc: 'Guide dettagliate delle destinazioni per nomadi digitali nel mondo' },
    },
    stats: {
      countries: 'Paesi',
      cities: 'Città',
      languages: 'Lingue',
    },
  },
  login: {
    login: 'Accedi',
    register: 'Registrati',
    subtitle: 'Accedi a NomadMate per gestire la tua vita da nomade',
    registerSubtitle: 'Crea un account per iniziare il tuo viaggio da nomade digitale',
    email: 'E-mail',
    emailPlaceholder: 'tua@email.com',
    emailInvalid: 'Inserisci un indirizzo e-mail valido',
    username: "Nome utente",
    usernamePlaceholder: 'Inserisci il nome utente',
    password: 'Password',
    passwordPlaceholder: '••••••••',
    passwordTooShort: 'La password deve avere almeno 6 caratteri',
    confirmPassword: 'Conferma password',
    confirmPasswordPlaceholder: 'Ridigita la password',
    passwordMismatch: 'Le password non corrispondono',
    loading: 'Accesso in corso...',
    error: 'Accesso fallito, riprova',
    orContinueWith: 'Oppure continua con',
    noAccount: 'Non hai un account?',
    hasAccount: 'Hai già un account?',
  },
  dashboard: {
    welcome: 'Bentornato, {name}',
    subtitle: 'Panoramica della tua vita da nomade',
    stats: {
      activeVisas: 'Visti attivi',
      daysUntilExpiry: 'Giorni alla scadenza',
      citiesCompared: 'Città confrontate',
      timezones: 'Fusi monitorati',
    },
    expiryAlerts: 'Avvisi scadenza visto',
    noAlerts: 'Nessun avviso di scadenza',
    daysLeft: '{days} giorni rimasti',
    worldClocks: 'Orologi mondiali',
    quickActions: 'Azioni rapide',
    actions: {
      visa: 'Tracciamento visto',
      cost: 'Confronto costi',
      timezone: 'Fusi orari',
      tax: 'Assistente fiscale',
      guide: 'Guida città',
    },
    recentActivity: 'Attività recente',
    noActivity: 'Nessuna attività recente',
  },
  visa: {
    title: 'Gestione visti',
    subtitle: 'Traccia e gestisci le informazioni sui visti',
    searchPlaceholder: 'Cerca per paese...',
    allRegions: 'Tutte le regioni',
    regions: {
      europe: 'Europa',
      asia: 'Asia',
      americas: 'Americhe',
      oceania: 'Oceania',
    },
    noCountries: 'Nessun paese trovato',
    requirements: 'Requisiti',
    documents: 'Documenti richiesti',
    track: 'Traccia questo visto',
    applyUrl: 'Link di richiesta',
    myTracked: 'I miei visti tracciati',
  },
  cost: {
    title: 'Costo della vita',
    subtitle: 'Confronta il costo della vita tra diverse città',
    selectCities: 'Seleziona città',
    selectHint: 'Seleziona 2-4 città da confrontare',
    compare: 'Confronta',
    selectedCount: '{count} città selezionate',
    comparison: 'Confronto',
    category: 'Categoria',
    nomadScore: 'Punteggio nomade',
    budgetFinder: 'Cerca budget',
    budgetPlaceholder: 'Inserisci budget mensile',
    findCities: 'Trova città',
    aiSuggestion: 'Suggerimenti IA in arrivo',
  },
  timezone: {
    title: 'Gestione fusi orari',
    subtitle: 'Gestisci orari e riunioni multi-fuso',
    addTimezone: 'Aggiungi fuso orario',
    noTimezones: 'Clicca sopra per aggiungere fusi orari',
    meetingScheduler: 'Pianificatore riunioni',
    meetingHint: 'Seleziona i fusi orari dei partecipanti per trovare il momento migliore',
    findMeeting: 'Trova orario riunione',
    finding: 'Ricerca in corso...',
    bestTime: 'Miglior orario',
    workingOverlap: 'Sovrapposizione orario lavorativo',
  },
  tax: {
    title: 'Assistente fiscale',
    subtitle: 'Calcolo fiscale transfrontaliero e conformità',
    rules: 'Regole fiscali',
    selectCountry: 'Seleziona paese',
    thresholdDays: 'Soglia giorni di residenza',
    days: 'giorni',
    taxRates: 'Aliquote fiscali',
    reportingRequirements: 'Obblighi di dichiarazione',
    importantDates: 'Date importanti',
    residenceTracker: 'Tracciamento giorni di residenza',
    noResidenceDays: 'Nessun giorno di residenza registrato',
    riskIndicator: 'Indicatore di rischio fiscale',
    noRiskData: 'Nessun dato di rischio disponibile',
    countries: {
      portugal: 'Portogallo',
      thailand: 'Tailandia',
      spain: 'Spagna',
      germany: 'Germania',
      estonia: 'Estonia',
      georgia: 'Georgia',
      croatia: 'Croazia',
      mexico: 'Messico',
      colombia: 'Colombia',
      indonesia: 'Indonesia',
      japan: 'Giappone',
      southKorea: 'Corea del Sud',
      unitedKingdom: 'Regno Unito',
      unitedStates: 'Stati Uniti',
    },
  },
  guide: {
    title: 'Guida città',
    subtitle: 'Guide delle destinazioni per nomadi digitali nel mondo',
    allContinents: 'Tutti',
    noCities: 'Nessuna città trovata',
    backToList: 'Torna alla lista',
    internetQuality: 'Qualità Internet',
    safetyRating: 'Valutazione sicurezza',
    climate: 'Clima',
    communitySize: 'Dimensione comunità',
    coworkingSpaces: 'Spazi di coworking',
    noCoworking: 'Nessuno spazio di coworking disponibile',
    day: 'giorno',
  },
  settings: {
    title: 'Impostazioni',
    subtitle: 'Gestisci il tuo account e le preferenze',
    profile: 'Profilo',
    username: "Nome utente",
    email: 'E-mail',
    saveProfile: 'Salva profilo',
    saving: 'Salvataggio...',
    language: 'Lingua',
    notifications: 'Notifiche',
    visaExpiryNotif: 'Promemoria scadenza visto',
    taxReminderNotif: 'Promemoria fiscali',
    appearance: 'Aspetto',
    light: 'Chiaro',
    dark: 'Scuro',
    baseTimezone: 'Fuso orario base',
    dangerZone: 'Zona pericolosa',
    dangerDesc: 'Queste azioni sono irreversibili, procedi con cautela',
    deleteAccount: 'Elimina account',
    confirmDelete: "Conferma eliminazione dell'account",
    confirmDeleteDesc: "Questo eliminerà definitivamente il tuo account e tutti i dati. Questa azione è irreversibile.",
    cancel: 'Annulla',
    confirm: 'Elimina',
  },
  about: {
    title: 'Chi siamo',
    subtitle: 'NomadMate - Assistente per nomadi digitali',
    version: 'Versione',
    versionNumber: '1.0.0',
    description: "NomadMate è un assistente progettato per nomadi digitali, che offre gestione visti, confronto costi di vita, gestione fusi orari, calcolo fiscale e guide cittadine per facilitare la tua vita nomade globale.",
    openSource: 'Ringraziamenti open source',
    openSourceDesc: 'Questo progetto è costruito sui seguenti eccellenti progetti open source',
    contact: 'Contattaci',
    support: 'Supporto tecnico',
    feedback: 'Feedback',
    privacyPolicy: 'Informativa sulla privacy',
    terms: 'Termini di servizio',
  },
}
